import * as React from "react";
import {handleNavigation, indexPath, routePaths} from "egold/routes";
import {RouteComponentProps, Redirect} from "react-router-dom";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import {IDeliveryStatus, IGoldOrderStatus, ITransactionDetails} from "StateInterface";
import {useEffect} from "react";
import {getDeliveryStatus, getInvoice, getOrderStatus, getTransactionStatus} from "egold/actions";
import {vendor} from "egold/egold-config";
import {capitalizeFirstLetter} from "utils";
import {imageBaseUrl} from "config";
import {downloadPDF} from "insurance/utils";
import {
    convertMilliSecondsToString,
    insideHeader,
    orderStatusVerification,
    toUpperCaseTxnType,
} from "egold/utils";
import {notifyAndroid} from "utils/android";
import {EVENT_NAMES} from "Dashboard/utils";

interface IConnectProps {
    dispatch?: (action: any) => void;
    invoiceLink: string;
    isAndroid: boolean;
    orderStatus: IGoldOrderStatus;
    transactionDetails: ITransactionDetails;
    deliveryStatus: IDeliveryStatus;
}
let transactionId: string | null = null;
let transactionType: string | null = null;
let paymentCompleted: boolean = false;

function OrderDetails(props: IConnectProps & RouteComponentProps ) {
    if (props.location.query) {
        transactionId = props.location.query.transaction_id;
        transactionType =  toUpperCaseTxnType(props.location.query.txn_type);
        paymentCompleted = props.location.query.paymentComplete;
    } else {
        return <Redirect to={`${indexPath}${routePaths.ORDERS}`}/>;
    }
    useEffect(() => {
        if (props.isAndroid) {
            notifyAndroid("TOOL_BAR_CONFIG", {visibility: false});
        }
        props.dispatch(getOrderStatus(vendor.SAFEGOLD, transactionType, Number(transactionId)));
        props.dispatch(getTransactionStatus(vendor.SAFEGOLD, transactionId));
    }, []);
    useEffect(() => {
        if (props.invoiceLink) {
            downloadPDF(props.invoiceLink, "invoice", props.isAndroid);
        }
    }, [props.invoiceLink]);
    useEffect(() => {
        if (props.transactionDetails && props.transactionDetails.type === "BUY" && paymentCompleted) {
        }
    }, [props.transactionDetails]);
    function fetchInvoice() {
        props.dispatch(getInvoice(vendor.SAFEGOLD, Number(transactionId)));
    }
    function fetchDeliveryStatus() {
        props.dispatch(getDeliveryStatus(vendor.SAFEGOLD, Number(transactionId)));
    }
    return(
        <div className="order-details-container">
            {insideHeader("Order Status", () => handleNavigation(routePaths.ORDERS), "#F5F5F5")}
            {
                props.transactionDetails && props.orderStatus &&
                renderDetails(props.transactionDetails, props.orderStatus)
            }
            {
                props.orderStatus && props.orderStatus.status.toLocaleLowerCase() === "success" &&
                renderInvoiceButton(transactionType, fetchInvoice, fetchDeliveryStatus)
            }
            {
                props.deliveryStatus && renderDeliveryStatus(props.deliveryStatus)
            }
            {renderRedirectButton()}
        </div>
    );
}
function renderDetails(txnDetails: ITransactionDetails,
                       orderStatus: IGoldOrderStatus,
                       ) {
    return(
        <div className="order-details-container mt-2">
            <div className="top-card">
                {orderStatusVerification(orderStatus.status)}
                <div className={"text-secondary text-center"}>
                    <small className="text-secondary">
                        Order ID: {txnDetails.transaction_id}&nbsp;
                        Date: {convertMilliSecondsToString(txnDetails.created_at)}
                    </small>
                </div>
            </div>
            <div>
                <div className="bottom-card d-flex justify-content-between mt-3 p-3">
                    <div>
                            <p>{`${capitalizeFirstLetter(txnDetails.type)} Gold`}</p>
                            <p>
                                <b>Rs. {txnDetails.amount || (txnDetails.quantity * txnDetails.rate).toFixed(2)}</b>
                            </p>
                            <p className="small-text pb-1">24k 99.5% Purity</p>
                        </div>
                        <img src={`${imageBaseUrl}/img/icons/eGold/gold-order.svg`} style={{width: "30px", float: "right"}}/>
                    </div>
            </div>
        </div>
    );
}
function renderInvoiceButton(type: string, fetchInvoice: any, fetchDeliveryStatus: any) {
    return(
        <div className="p-3 mt-3">
            <div className="d-flex w-100 justify-content-between">
                <span>From <br/>Safegold</span>
                <img src={`${imageBaseUrl}/img/icons/eGold/safegold_logo.svg`} style={{width: "90px", marginRight: "10px"}}/>
            </div>
            <div className="w-100 d-flex text-center">
                    <button className="invoice-btn" onClick={() => fetchInvoice()}>Download Invoice</button>
                {
                    type && type.includes("DELIVER") &&
                    <button className="invoice-btn" onClick={() => fetchDeliveryStatus()}>View Status</button>
                }
            </div>
        </div>
    );
}
function renderRedirectButton() {
    return(
        <div className="text-center mt-5"
             onClick={() => handleNavigation(routePaths.BUY_GOLD)}>
            <span className="go-to-dash">Go to Dashboard</span>
        </div>
    );
}
function renderDeliveryStatus(status: IDeliveryStatus) {
    return (
        <div className="my-2 mx-3 p-3 border">
            {status.delivery_status && <small>{status.delivery_status.split("_").join(" ")}</small>}
            {status.courier_tracking_id &&
            <small>
                Courier tracking id: {status.courier_tracking_id}
            </small>}
            {status.courier_company &&
            <small>
                Courier name: {status.courier_company}
            </small>}
            {status.tracking_link &&
            <small>
               Tracking Link: {status.tracking_link}
            </small>}
        </div>
    );
}
const mapStateToProps = (state: IReduxState): IConnectProps =>  {
    return {
        invoiceLink: state.eGold.invoiceLink,
        isAndroid: state.login.isAndroid,
        orderStatus: state.eGold.orderStatus,
        transactionDetails: state.eGold.transactionDetails,
        deliveryStatus: state.eGold.deliveryStatus,
    };
};
export default connect<IConnectProps, {}, {}>(mapStateToProps)(OrderDetails);
